import { Component, Injectable, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import "./multiStepIndicator.component.scss";

export enum MultiStepStatus {
    Todo,
    Failed,
    Completed
}

export interface IMultiStep {
    label: string;
    subText?: string;
    status: MultiStepStatus;
}

@Component({
    selector: "multi-step-indicator",
    template: require('./multiStepIndicator.component.html')
})
@Injectable()
export class MultiStepIndicatorComponent implements OnInit, OnChanges {

    @Input() steps: IMultiStep[];

    // ---

    hasSubText: boolean;

    constructor() {

        //this.steps = [];
        //this.steps.push({ label: "Created", status: MultiStepStatus.Completed, subText: "21st July" });
        //this.steps.push({ label: "Open", status: MultiStepStatus.Completed, subText: "3 hours" });
        //this.steps.push({ label: "SLA Expiry", status: MultiStepStatus.Failed, subText: "22nd July" });
        //this.steps.push({ label: "Closed", status: MultiStepStatus.Todo, subText: "23rd July" });
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {

        this.hasSubText = this.steps.find(s => s.subText) != null;
    }

    // --

}
